import Mock from 'mockjs';

export default ({mock}) => {
  if (!mock) return;
  Mock.mock('/test', 'get', () => {
    return {
        code:200,
      data: ['test']
    }
  })

}
